import { Subject } from 'rxjs';
import moment from 'moment';
import dayjs from 'dayjs';
import { session } from '..';
import crypt from './crypt';

class globalService {
    constructor() {
        this.reqInfoMap = new Map();
        this.commonEvent = new Subject();
        this.eventConnect = new Subject();
        this.authFlag = false;
        this.notAuthViewOpen = true;
        this.exptimeout = 900; // -- time idle
        this.discexpire = 30; // -- time expire tính từ thời điểm mất kết nối server
        this.req_timeout = 40000; // 15 seconds
        this.versionChange = '1.0.0';
        this.errorInfo = null;
        this.uploadtImg = '';
        this.defaultImg = '';
        this.prodImgPath = '';
        this.urlPostImg = '';
        this.configInfo = {};
        this.toastYN = [];
        this.timeServer = dayjs().format('YYYYMMDD');
        this.language = localStorage.getItem('i18nextLng2') || 'vi';
        this.timeoutConnect = 'timeout_30m';
        this.hotKeys = {};
        this.menu = [];
        this.userInfo = {};
        this.department = [];
        this.client_tp = '04';
        this.countConection = 0;
        // this.domain = 'https://cabinet-dev.chips.com.vn/'; //'https://ohnoseiko.com.vn/';
        this.domain = 'https://ohnoseiko.com.vn/';
        //---------------------------------------------
        this.networkState = {}; // trạng thái mạng (không realtime)
        this.sessionInfo = {
            comp_id: 0, //-- AA = 100
            phar_name: '',
            branch_id: '',
            branch_name: '',
            user_name: '',
            user_id: 0,
            user_levl: '',
            user_email: '',
            user_phone: '',
            last_login: '',
            uid_exp: 0,
        };

        /**
         * @param {String} notifyOnesignal chứa userId và pushToken của onesignal
         */
        this.notifyOnesignal = {
            userId: '',
            pushToken: '',
        };
        /**
         * @param {String} userInfo chứa email, phone, name của user từ social
         */
        this.userInfo = {};
        /**
         * @param {String} credentials chứa thông tin khi tạo tài khoản
         */
        this.credentials = {
            username: '',
            password: '',
        };
        /**
         * @param {String} isAutoLogin flag check có phải auto login hay không
         */
        this.isAutoLogin = false;
        // --------------------client_type
        // this.agent = JSON.parse(Crypt.deCode(sessionStorage.getItem('proc_data')))

        // -------------------------------------------
        this.setReqInfoMapValue = (key = 0, valObj = {}) => {
            // console.log('setReqInfoMapValue', valObj);
            this.reqInfoMap.set(key, valObj);
        };
        this.getReqInfoMapValue = (key) => {
            return this.reqInfoMap.get(key);
        };

        this.convUnixTime2StrDt = (unixTm, DateTp) => {
            const x = new Date(unixTm * 1000);
            const y = x.getFullYear();
            const m = x.getMonth() + 1;
            const sm = ('0' + m).slice(-2);
            const d = x.getDate();
            const sd = ('0' + d).slice(-2);
            let result = y + '' + sm + '' + sd;
            if (DateTp === 2) {
                const hours = '0' + x.getHours();
                const minutes = '0' + x.getMinutes();
                const seconds = '0' + x.getSeconds();
                result = result + '' + hours.substr(-2) + '' + minutes.substr(-2) + '' + seconds.substr(-2);
            }
            return result;
        };

        this.convertMultipleLanguages = (string) => {
            let str = `${string}`;
            let language = localStorage.getItem(session.LANGUAGE);
            if (!language) language = 'vi';
            if (str) {
                const arrSplit = str.split('|');
                if (!arrSplit) return str;
                if (language === 'vi') {
                    return arrSplit[0];
                } else if (language === 'en' && arrSplit[1]) {
                    return arrSplit[1];
                } else if (language === 'jp' && arrSplit[2]) {
                    return arrSplit[2] || arrSplit[1] || arrSplit[0];
                } else {
                    return arrSplit[0];
                }
            }
            return str;
        };

        this.convStrDt2UnixTime = (strTime) => {
            try {
                const y = Number(strTime.substr(0, 4));
                const m = Number(strTime.substr(4, 2)) - 1;
                const d = Number(strTime.substr(6, 2));
                const dates = new Date(y, m, d, 15, 0, 0);
                const unixtime = dates.getTime() / 1000;
                // const unixtime = Number(dates.toISOString())
                return unixtime;
            } catch (error) {
                // this.logMessage('Error at convStrDt2UnixTime: ' + error);
                return -1;
            }
        };
        this.convStrDtime2UnixTime = (strTime) => {
            try {
                //example: strTime = 2020 05 22 10 01 02
                const y = Number(strTime.substr(0, 4));
                const m = Number(strTime.substr(4, 2)) - 1;
                const d = Number(strTime.substr(6, 2));
                const h = Number(strTime.substr(8, 2));
                const mi = Number(strTime.substr(10, 2));
                const s = Number(strTime.substr(12, 2));
                const dates = new Date(y, m, d, h, mi, s);
                const unixtime = dates.getTime() / 1000;
                return unixtime;
            } catch (error) {
                // this.logMessage('Error at convStrDt2UnixTime: ' + error);
                return -1;
            }
        };

        this.convDate2StrDt = (Datt) => {
            const y2 = Datt.getFullYear();
            const m2 = Datt.getMonth() + 1;
            const sm = ('0' + m2).slice(-2);
            const d2 = Datt.getDate();
            const sd = ('0' + d2).slice(-2);
            const result = y2 + '' + sm + '' + sd;
            return result;
        };

        this.filterStrBfParse = (str) => {
            if (!str || str === undefined) return '';
            let result = '',
                i = 0;
            for (i = 0; i < str.length; i++) {
                let tt = str.substr(i, 1);
                const ascII = tt.charCodeAt(0);
                if (ascII <= 31) {
                    tt = '';
                }
                if (ascII === 4) {
                    tt = "'|'";
                } // -- EOT
                result = result + tt;
            }
            return result;
        };

        this.logMessage = (flag = false, ...message) => {
            if (flag) {
                // const now = new Date(); consoleSocket
                // console.log(`Time: ${now.toLocaleTimeString()}.${now.getMilliseconds()}>`, ...message); consoleSocket
            }
            return;
        };

        this.filterNumber = (numberstr) => {
            if (typeof numberstr === 'number') return numberstr;
            else if (numberstr !== null && numberstr.length > 0) {
                return Number(numberstr.replace(/\D/g, ''));
            }
        };

        this.addZero = (x, n) => {
            while (x.toString().length < n) {
                x = '0' + x;
            }
            return x;
        };

        this.convDate2StrTime = (Datt) => {
            const y2 = Datt.getFullYear();
            const m2 = Datt.getMonth() + 1;
            const sm = ('0' + m2).slice(-2);
            const d2 = Datt.getDate();
            const sd = ('0' + d2).slice(-2);
            const hr = Datt.getHours() + 1;
            const hrs = ('0' + hr).slice(-2);
            const mi = Datt.getMinutes() + 1;
            const mis = ('0' + mi).slice(-2);
            const ss = Datt.getSeconds() + 1;
            const sss = ('0' + ss).slice(-2);
            const result = y2 + '' + sm + '' + sd + '' + hrs + '' + mis + '' + sss;
            return result;
        };

        this.dateToChartTimeMinute = (date) => {
            return (
                Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    date.getHours(),
                    date.getMinutes(),
                    date.getSeconds(),
                    0
                ) / 1000
            );
        };
        this.convertUTCDateToLocalDate = (date) => {
            var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();

            newDate.setHours(hours + offset);

            return newDate;
        };

        this.arr_diff = (a1, a2) => {
            const a = [],
                diff = [];

            for (let i = 0; i < a1.length; i++) {
                a[a1[i]] = true;
            }

            for (let i = 0; i < a2.length; i++) {
                if (a[a2[i]]) {
                    delete a[a2[i]];
                } else {
                    a[a2[i]] = true;
                }
            }

            for (let k in a) {
                diff.push(k);
            }

            return diff;
        };

        this.intersect = (arr1, arr2) => {
            const result = [];
            for (let i = 0; i < arr1.length; i++) {
                if (arr2.indexOf(arr1[i]) === -1) result.push(arr1[i]);
            }
            return result;
        };

        this.focusInput = (id, sleep) => {
            if (sleep) {
                setTimeout(() => {
                    const ele = document.getElementById(id);
                    if (ele) ele.focus();
                }, sleep);
            } else {
                const ele = document.getElementById(id);
                if (ele) ele.focus();
            }
        };

        this.getRandomArbitrary = (min, max) => {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        this.validateEmail = (email) => {
            const expression = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return expression.test(email.toLowerCase());
        };

        this.verifyDt = (dt, month, year) => {
            if (!dt || !month || !year || isNaN(dt) || isNaN(month) || isNaN(year)) return false;
            let varDt, varMonth, varYear;
            varDt = Number(dt) < 10 ? '0' + dt : '' + dt;
            varMonth = Number(month) < 10 ? '0' + month : '' + month;
            varYear = '' + year;
            let date = moment(varYear + '-' + varMonth + '-' + varDt);
            if (!date.isValid) return false;
            return true;
        };

        this.formatDate = (value, formatIn, formatOut) => {
            if (!value || value === '' || value === null) return '';
            let date = moment(value, formatIn || 'DDMMYYYYHHmmss').format(
                formatOut ? formatOut : 'DD/MM/YYYY HH:mm:ss'
            );
            if (date === 'Invalid Date') return '';
            return date;
        };

        this.convertTimestampToDate = (timeStampValue) => {
            if (!timeStampValue) return 'Invalid Date';
            const date = new Date(+timeStampValue);
            let result = `${date.getDate()}/${
                date.getUTCMonth() + 1
            }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getMilliseconds()}`;
            return result;
        };

        // ---- Nhóm các đối tượng của mảng theo một thuộc tính
        this.groupBy = (objectArray, property) => {
            return objectArray.reduce(function (accumulator, obj) {
                let key = obj[property];
                if (!accumulator[key]) {
                    accumulator[key] = [];
                }
                accumulator[key].push(obj);
                return accumulator;
            }, {});
        };
        // Lấy ra tên các đối tượng trong mãng
        this.convert = (string) => {
            let result = '';
            if (typeof string === 'string') {
                const data = JSON.parse(string);
                for (let i = 0; i < data.length; i++) {
                    result += data[i].label + ', ';
                }
            }
            if (typeof string === 'object') {
                for (let i = 0; i < string.length; i++) {
                    if (i < string.length - 1) {
                        result += string[i].label + ' - ';
                    }
                    if (i === string.length - 1) {
                        result += string[i].label;
                    }
                }
            }
            return result;
        };
        this.getSessionsCategory = (key = 'category') => {
            const data = sessionStorage.getItem(key);
            if (data) {
                try {
                    return JSON.parse(data);
                } catch (error) {
                    // console.log(error); consoleSocket
                    return [];
                }
            }
        };
        this.setSessionsCategory = (data, key = 'category') => {
            // console.log(data);consoleSocket
            // console.log(this.getSessionsCategory()); consoleSocket
            const dataArr = sessionStorage.getItem(key);
            if (dataArr) {
                try {
                    const arrData = JSON.parse(dataArr);
                    arrData.push(data);
                    sessionStorage.setItem(key, arrData);
                    return true;
                } catch (error) {
                    // console.log(error); consoleSocket
                    return false;
                }
            } else {
                sessionStorage.setItem(key, [data]);
            }
        };
        this.setClient_tp = () => {
            // Kiểm tra xem trình duyệt có chạy trên một thiết bị di động hay không
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            // Kiểm tra xem trình duyệt có chạy trên một ứng dụng trên desktop hay không
            const isDesktopApp = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;

            // Kiểm tra kích thước màn hình của người dùng
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const aspectRatio = width / height;

            // Xác định loại màn hình dựa trên các thông tin trên
            if (isMobile && /Android/i.test(navigator.userAgent)) {
                return (this.client_tp = '01'); //'01 mobile android';
            } else if (isMobile && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                return (this.client_tp = '02'); //'02 mobile ios';
            } else if (
                isMobile &&
                !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            ) {
                return (this.client_tp = '03'); //'03 mobile web';
            } else if (!isMobile && aspectRatio < 1.5) {
                return (this.client_tp = '04'); // '04 website';
            } else if (isDesktopApp) {
                return (this.client_tp = '05'); //'05 desktop app';
            } else {
                return (this.client_tp = '04'); //'04 website';
            }
        };
        this.versionCompare = (v1, v2, options) => {
            var lexicographical = options && options.lexicographical,
                zeroExtend = options && options.zeroExtend,
                v1parts = v1.split('.'),
                v2parts = v2.split('.');

            function isValidPart(x) {
                return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
            }

            if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
                return NaN;
            }

            if (zeroExtend) {
                while (v1parts.length < v2parts.length) v1parts.push('0');
                while (v2parts.length < v1parts.length) v2parts.push('0');
            }

            if (!lexicographical) {
                v1parts = v1parts.map(Number);
                v2parts = v2parts.map(Number);
            }

            for (var i = 0; i < v1parts.length; ++i) {
                if (v2parts.length === i) {
                    return 1;
                }

                if (v1parts[i] === v2parts[i]) {
                    continue;
                } else if (v1parts[i] > v2parts[i]) {
                    return 1;
                } else {
                    return -1;
                }
            }

            if (v1parts.length !== v2parts.length) {
                return -1;
            }

            return 0;
        };
        this.getLocalStorageCabinetLogin = (key = 'cabinet') => {
            try {
                const factory_id = localStorage.getItem('factory_id');
                // console.log('factory_id', factory_id);

                const data = localStorage.getItem(key + '_' + factory_id);
                if (data) {
                    try {
                        return JSON.parse(crypt.deCode(data));
                    } catch (error) {
                        console.log(error);
                        return null;
                    }
                } else {
                    return null;
                }
            } catch (error) {
                console.log('ERROR getLocalStorageCabinetLogin:', error);

                return null;
            }
        };
        this.getLocalStorageCabinet = (key = 'cabinet') => {
            try {
                const userDataLocal = sessionStorage.getItem('proc_data');
                if (!userDataLocal) {
                    // console.warn('Không có userDataLocal: ', userDataLocal);

                    return null;
                }
                const userData = JSON.parse(crypt.deCode(userDataLocal));
                const keyResult = key + '_' + userData?.factory_id || '0';
                const data = localStorage.getItem(keyResult);
                // console.log('keyResult', keyResult);
                // console.log('localStorage.getItem cabinet', data);

                if (data) {
                    const r = JSON.parse(crypt.deCode(data));
                    // console.log('r', r);

                    return r;
                }
                return null;
            } catch (error) {
                if (error && JSON.stringify(error) !== '{}')
                    alert(
                        'Không lấy được dữ liệu của trình duyệt, vui lòng kiểm tra lại hoặc sử dụng 1 trình duyệt khác' +
                            JSON.stringify(error)
                    );
                console.log('error', error);
                return null;
            }
        };
        this.setLocalStorageCabinet = (data, key = 'cabinet') => {
            try {
                const userDataLocal = sessionStorage.getItem('proc_data');
                const userData = JSON.parse(crypt.deCode(userDataLocal));
                const enCode = crypt.enCode(JSON.stringify(data));
                const keyResult = key + '_' + userData?.factory_id || '0';
                console.log('keyResult', keyResult);
                console.log('enCode', enCode);

                localStorage.setItem(keyResult, enCode);
                localStorage.setItem('factory_id', userData?.factory_id);
            } catch (error) {
                if (error && JSON.stringify(error) !== '{}')
                    alert(
                        `Không lưu được dữ liệu trên trình duyệt, vui lòng kiểm tra lại hoặc sử dụng 1 trình duyệt khác, ${JSON.stringify(
                            error
                        )}`
                    );
                console.log('error', error);
            }
            // console.log(data);
        };
        this.convertMultipleDate = (string) => {
            let str = `${string}`;
            let language = localStorage.getItem(session.LOCAL_LANGUAGE);
            if (!language) language = 'vi';
            if (str) {
                if (language === 'vi') {
                    return moment(str, 'YYYYMMDD').format('DD-MM-YYYY');
                } else if (language === 'en') {
                    return moment(str, 'YYYYMMDD').format('YYYY-MM-DD');
                } else if (language === 'jp') {
                    return moment(str, 'YYYYMMDD').format('YYYY-MM-DD');
                } else {
                    return moment(str, 'YYYYMMDD').format('YYYY-MM-DD');
                }
            }
            return moment(str, 'YYYYMMDD').format('YYYY-MM-DD');
        };
        this.urlPostFaceImage = this.domain + 'upload-face-image/';
        this.urlPostProductImage = this.domain + 'uplimgprod';
        this.urlGetFaceImage = (fileName) => {
            return this.domain + 'face-image/' + fileName;
        };
        this.urlGetProductImage = (fileName) => {
            return this.domain + 'upload/product/' + fileName;
        };
        this.urlDownloadFileExcel = (fileName) => {
            return this.domain + 'upload/product/' + fileName;
        };
    }
}
const theInstance = new globalService();
export default theInstance;
